__turbopack_context__.v({
  "alignLeft": "CopyCard-module-scss-module__MDvK3q__alignLeft",
  "copy": "CopyCard-module-scss-module__MDvK3q__copy",
  "textContainer": "CopyCard-module-scss-module__MDvK3q__textContainer",
});
